export default __webpack_public_path__ + "static/media/maestro.744b9c86.svg";